import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCurrentAgent, logoutAgentAndRedirect } from "../../lib/agentAuth";
import { initialsFromName } from "../../lib/catalog";
import { formatAgencyRole } from "../../lib/agencyAccess";

export default function ProfilePanel() {
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const menuRef = useRef(null);
  const name = profile?.full_name || profile?.utp_full_name || "Way2 Umrah Agent";
  const email = profile?.email || profile?.utp_email || "";
  const roleLabel = formatAgencyRole(profile);
  const initials = initialsFromName(name);

  useEffect(() => {
    let alive = true;

    fetchCurrentAgent()
      .then((current) => {
        if (alive) setProfile(current);
      })
      .catch(() => {
        if (alive) setProfile(null);
      });

    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <div className={`dropdown profile-dropdown ${open ? "show" : ""}`} ref={menuRef}>
      <button
        className={`has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center profile-dropdown-toggle${open ? " show" : ""}`}
        type="button"
        aria-expanded={open}
        aria-label="Profile"
        onClick={() => setOpen((value) => !value)}
      >
        <span className="fw-semibold text-primary-600">{initials}</span>
      </button>
      <div className={`dropdown-menu dropdown-menu-end shadow-lg border-0 profile-dropdown-menu ${open ? "show" : ""}`}>
        <div className="profile-dropdown-head">
          <div className="profile-dropdown-identity">
            <span className="profile-dropdown-avatar w-40-px h-40-px rounded-circle bg-primary-600 text-white d-flex justify-content-center align-items-center fw-semibold">
              {initials}
            </span>
            <div className="profile-dropdown-meta">
              <h6 className="text-lg text-primary-light fw-semibold mb-0">{name}</h6>
              <span className="text-secondary-light fw-medium text-sm">{email || roleLabel}</span>
              {profile ? (
                <span className="text-secondary-light fw-medium text-sm d-block">{roleLabel}</span>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            className="profile-dropdown-close agent-icon-btn hover-text-danger"
            aria-label="Close profile menu"
            onClick={() => setOpen(false)}
          >
            <iconify-icon icon="radix-icons:cross-1"></iconify-icon>
          </button>
        </div>
        <ul className="to-top-list profile-dropdown-list d-grid gap-1">
          <li>
            <Link className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3" to="/settings" onClick={() => setOpen(false)}>
              <iconify-icon icon="solar:user-linear" className="icon text-xl"></iconify-icon> My Profile
            </Link>
          </li>
          <li>
            <Link className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3" to="/notifications" onClick={() => setOpen(false)}>
              <iconify-icon icon="solar:bell-outline" className="icon text-xl"></iconify-icon> Notifications
            </Link>
          </li>
          <li>
            <Link className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3" to="/settings" onClick={() => setOpen(false)}>
              <iconify-icon icon="icon-park-outline:setting-two" className="icon text-xl"></iconify-icon> Settings
            </Link>
          </li>
          <li>
            <button
              type="button"
              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 w-100"
              onClick={async () => {
                setOpen(false);
                await logoutAgentAndRedirect();
              }}
            >
              <iconify-icon icon="lucide:power" className="icon text-xl"></iconify-icon> Log Out
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}
